import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Switch, Route } from 'react-router';
import { Redirect } from 'react-router-dom';

import { GUIDES_MENU } from '../core/MenuComponent/MenuConstants';
import BreadcrumbsComponent from '../core/BreadcrumbsComponent/BreadcrumbsComponent';
import MenuComponent from '../core/MenuComponent/MenuComponent';
import IntroductionComponent from './Introduction/IntroductionComponent';
import MMSIntegrationComponent from './MMSIntegration/MMSIntegrationComponent';
import RealTimeAvailabilityComponent from './RealTimeAvailability/RealTimeAvailabilityComponent';

import './guides.scss';

class GuidesComponent extends React.Component {
    getMenuItems = (menuItems) => Object.keys(menuItems).map((keyItem) => {
        const menuItem = menuItems[keyItem];
        const { params } = this.props.match;
        const subMenu = menuItem && menuItem.subMenu;

        return {
            ...menuItem,
            url: `/guides/${keyItem}`,
            active: params.menuItem === keyItem,
            subMenu: subMenu && Object.keys(subMenu).map((subMenuItem) => ({
                ...subMenu[subMenuItem],
                url: subMenuItem,
                active: params.subMenuItem === subMenuItem,
            })),
        };
    })

    render() {
        const props = this.props;
        const { menuItem } = props.match.params;

        if (!menuItem) {
            return <Redirect to={`/guides/introduction`} />;
        }

        return <div className="guides-component container">
            <div className="content">
                <div className='sticky-wrapper'>
                    <BreadcrumbsComponent class="breadcrumbs" />
                    <MenuComponent {...props} menuTitle={'Guides'} menuItems={this.getMenuItems(GUIDES_MENU)} />
                </div>
                <div className="content-wrapper">
                    <Switch>
                        <Route path='/guides/introduction' component={() =>
                            <IntroductionComponent />
                        } />
                        <Route path='/guides/mms-integration' component={() =>
                            <MMSIntegrationComponent />
                        } />
                        <Route path='/guides/real-time-availability' component={() =>
                            <RealTimeAvailabilityComponent />
                        } />
                    </Switch>
                </div>
            </div>
        </div>;
    }
}

GuidesComponent.propTypes = {
    //...MENU_PROP_TYPES,
    match: PropTypes.object.isRequired,
};

export default withRouter(GuidesComponent);



// WEBPACK FOOTER //
// ./src/components/guides/GuidesComponent.js